<template>
  <div class="content">
    <div class="content-logo-container">
      <image-item
        class="img"
        :url="item.itemImageUrl"
        :w="164"
        :h="164"
        mode="aspectFit"
        bg="#f8f8f8"
      ></image-item>
    </div>
    <div class="content-column-container">
      <div class="content-title" :style="item.startChPunctuation ? 'text-indent: -.5em;' : ''">
        <span>{{ item.lot ? 'Lot' + item.lot + ' ' : '' }}{{ item.skuName || item.itemName }}</span>
      </div>
      <div class="content-subject">{{ item.skuPropertiesText }}</div>
      <div class="content-price-container">
        <div class="content-price">
          {{ mark ? mark.mark : '¥' }} {{ setFixed(item.itemPrice) }}
          <vip-price v-if="item.vipPriceData" :showType="2" :priceData="item.vipPriceData" />
        </div>
        <span class="content-count">x{{ item.itemCount }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import vipPrice from '@/views/components/vipPrice';
import imageItem from '@/views/components/imageItem';
export default {
  props: ['item', 'mark'],
  components: {
    vipPrice,
    imageItem,
  },
  created() {},
  methods: {
    setFixed(value) {
      let number = Number(value);
      number = number.toFixed(2);
      if (number === '0.00') {
        return 0;
      }
      return number;
    },
  },
};
</script>
<style scoped>
.content {
  width: 100%;
  height: 82px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.content-logo-container {
  width: 82px;
  height: 82px;
  margin-right: 12px;
  overflow: hidden;
}
.content-logo-container .img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  display: block;
}

.content-column-container {
  flex: 1;
  height: 82px;
  font-size: 14px;
  color: #3c3c3c;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  line-height: 20px;
  position: relative;
}

.content-title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
}

.content-subject {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  overflow: hidden;
  margin-top: 10rpx;
}

.content-price-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 1px;
  height: 14px;
}

.content-price {
  flex: 1;
  height: 14px;
  font-size: 14px;
  font-family: SFProDisplay-Medium;
  font-weight: 500;
  color: rgba(255, 62, 62, 1);
  line-height: 14px;
  display: flex;
}
.content-count {
  text-align: right;
  font-size: 13px;
  color: #999;
  line-height: 14px;
}
</style>
